export default __webpack_public_path__ + "static/media/folder.ac94df93.svg";